export default __webpack_public_path__ + "static/media/BlindStateOff.2bc1f930.svg";